import { AccountData } from '../api';

// Same LTR isolate as refundFormat.ts, which cannot be imported in pure-logic tests.
const LEFT_TO_RIGHT_ISOLATE_START = '\u2066';
const POP_DIRECTIONAL_ISOLATE = '\u2069';
const CENTS_PER_UNIT = 100;
const RATE_MILLI_PER_PERCENT = 1000;
const FEE_DIVISOR = 100000;
const FEE_HALF_UP = 50000;
const FRACTION_DIGITS = 2;

export const isBookingFeeOn = (account?: AccountData): boolean =>
  !!account?.booking_fee?.enabled && !!account.booking_fee.available;

export const bookingFeeCents = (amountCents: number, ratePercent: number): number => {
  const rateMilli = Math.round(ratePercent * RATE_MILLI_PER_PERCENT);
  return Math.floor((amountCents * rateMilli + FEE_HALF_UP) / FEE_DIVISOR);
};

export const bookingFeeAmount = (amount: number, account?: AccountData): number => {
  if (!isBookingFeeOn(account) || amount <= 0) {
    return 0;
  }
  const amountCents = Math.round(amount * CENTS_PER_UNIT);
  return bookingFeeCents(amountCents, account?.booking_fee?.rate_percent ?? 0) / CENTS_PER_UNIT;
};

export const withBookingFee = (amount: number, account?: AccountData): number =>
  Math.round(amount * CENTS_PER_UNIT + bookingFeeAmount(amount, account) * CENTS_PER_UNIT) / CENTS_PER_UNIT;

export const formatMoney = (amount: number, account: AccountData): string => {
  const locale = account.currency.toLowerCase() === 'ils' ? 'he-IL' : 'en-US';
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: account.currency,
    minimumFractionDigits: FRACTION_DIGITS,
    maximumFractionDigits: FRACTION_DIGITS,
  });
  return `${LEFT_TO_RIGHT_ISOLATE_START}${formatter.format(amount)}${POP_DIRECTIONAL_ISOLATE}`;
};
